export default __webpack_public_path__ + "static/media/x-logo-white.4d73a492.png";